import { render, staticRenderFns } from "./redirectUrlScan.vue?vue&type=template&id=cf2237f2&scoped=true&"
import script from "./redirectUrlScan.vue?vue&type=script&lang=js&"
export * from "./redirectUrlScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2237f2",
  null
  
)

export default component.exports